module.exports = __webpack_public_path__ + "static/media/dodawanie_w_zakresie_10_uzupełnianka.4a64517c.pdf";